var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"white--text",attrs:{"color":"success"}},[_vm._v(" Регистрация прошла успешно. Проверьте почту для дальнейших инструкций. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }